var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#435877;}.b{fill:#fff;stroke:#fff;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 -215)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(-20 215)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.646 222.063)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-4343.157-119.38a7.453,7.453,0,0,0-5.107,1.943,7.677,7.677,0,0,0-2.324,5.808c0,4.158,6.862,11.246,7.154,11.546a.4.4,0,0,0,.285.121h0a.4.4,0,0,0,.284-.119c.293-.3,7.158-7.307,7.158-11.547A7.356,7.356,0,0,0-4343.157-119.38Zm.012,18.439c-1.3-1.394-6.643-7.3-6.643-10.688a6.9,6.9,0,0,1,2.068-5.223,6.657,6.657,0,0,1,4.563-1.729,6.513,6.513,0,0,1,6.653,6.952C-4336.5-108.176-4341.839-102.323-4343.146-100.941Z",
    transform: "translate(4350.588 119.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-4326.735-101.68a3.925,3.925,0,0,0-3.92,3.92,3.925,3.925,0,0,0,3.92,3.92,3.925,3.925,0,0,0,3.92-3.92A3.925,3.925,0,0,0-4326.735-101.68Zm0,7.042a3.125,3.125,0,0,1-3.121-3.121,3.125,3.125,0,0,1,3.121-3.121,3.125,3.125,0,0,1,3.121,3.121A3.125,3.125,0,0,1-4326.735-94.638Z",
    transform: "translate(4334.175 104.806)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ddd3c18c7c246e03c452f8aad3d9e4cc.svg";
export { ForwardRef as ReactComponent };